import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cdd84e44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "control is-hidden-mobile" }

interface PickDates {
  start: Moment;
  end: Moment;
}

import moment, { Moment } from "moment";
import { storeToRefs } from "pinia";
import { reactive, ref, watch, computed } from "vue";
import { UseDateStore } from "./Stores/DateStore";
import { UseProgramStore } from "./Stores/ProgramStore";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";

const __default__ = {
  components: { VueCtkDateTimePicker },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { getCurrentProgramName } = storeToRefs(UseProgramStore());
const { getDateFromAsDate, getDateToAsDate } = storeToRefs(UseDateStore());
const { setDateFrom, setDateTo } = UseDateStore();

const pickerDates = reactive<PickDates>({
  end: moment().startOf("day").subtract(1, "day"),
  start: moment().subtract(7, "day"),
});
const date = computed({
  get(): PickDates {
    return pickerDates;
  },
  set(val: PickDates) {
    pickerDates.start = val.start;
    //Need to subtract one day as the v-model value is adding a day to the end. Don't know why.
    pickerDates.end = val.end;
  },
});

const maxDate = ref(
  moment().startOf("day").subtract(1, "day").format("YYYY-MM-DD")
);

const shortcuts = ref([
  { key: "week", label: "Last 7 days", value: 7 },
  { key: "month", label: "Last 30 days", value: 30 },
  { key: "year", label: "Last 90 days", value: 90 },
  { key: "thismonth", label: "This month", value: "month" },
  { key: "lastmonth", label: "Last month", value: "-month" },
]);
const setDateFromMethod = (val: Moment) => {
  if (
    moment(val).startOf("day").unix() !==
    moment(getDateFromAsDate.value).startOf("day").unix()
  ) {
    setDateFrom(val);
  }
};
const setDateToMethod = (val: Moment) => {
  if (
    moment(val).startOf("day").unix() !==
    moment(getDateToAsDate.value).startOf("day").unix()
  ) {
    setDateTo(val);
  }
};
const validateDatesOnHidden = () => {
  if (!pickerDates.end) {
    let end = moment().subtract(1, "day");
    pickerDates.end = end;
    setDateFromMethod(pickerDates.start);
    setDateToMethod(end);
  }
};

const rangeValidation = () => {
  if (!pickerDates.start) {
    pickerDates.start = moment().subtract(1, "day");
  }
  // If its after yesterday, take it back to yesterday
  if (
    pickerDates.end &&
    moment(moment(pickerDates.end).startOf("day"), "yyyy-mm-dd hh:mm:ss").diff(
      moment(maxDate.value, "YYYY-MM-DD"),
      "days"
    ) > 0
  ) {
    pickerDates.end = moment().startOf("day").subtract(1, "day");
  }

  if (pickerDates.start && pickerDates.end) {
    setDateFromMethod(pickerDates.start);
    setDateToMethod(pickerDates.end);
  }
};

watch(pickerDates, () => {
  rangeValidation();
});

return (_ctx: any,_cache: any) => {
  const _component_ctk_date_picker = _resolveComponent("ctk-date-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(getCurrentProgramName)), 1),
    _createVNode(_component_ctk_date_picker, {
      modelValue: _unref(date),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(date) ? (date).value = $event : null)),
      range: true,
      right: true,
      label: "Date selection",
      formatted: "DD/MM/YYYY",
      format: "YYYY-MM-DD hh:mm:ss",
      onIsHidden: validateDatesOnHidden,
      onInput: rangeValidation,
      "custom-shortcuts": shortcuts.value,
      shortcut: "week",
      "max-date": maxDate.value,
      "input-size": "sm",
      noClearButton: true,
      class: "program-date-picker",
      "first-day-of-week": 1,
      id: "thenavigationone"
    }, null, 8, ["modelValue", "custom-shortcuts", "max-date"])
  ]))
}
}

})